import { Button, Card, CardActions, CardContent, CardHeader, CardMedia, makeStyles, Typography } from '@material-ui/core';
import * as React from 'react';
import logo from "../images/placeholder.png";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
        textAlign: "center"
    },
    media: {
        height: 390,
        backgroundSize: "contain",
        objectFit: "contain",
        objectPosition: "center center"
    },
    image: {
        maxHeight: 390,
        maxWidth: "100%"
    },
    cardAction: {
        justifyContent: "center"
    }
}));

const onError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = logo;
}


interface IParams {
    product: string,
    model: string,
    serial: string,
    img: string,
    productDescription: string
}


export const ProductSummary: React.FC<IParams> = params => {
    const { product, model, img, productDescription, serial } = params;
    const [partsUrl, setPartsUrl] = React.useState("");
    const classes = useStyles();

    const getEmail = (): string => {
        if (serial) {
            return "mailto:QRCodesupport@hussmann.com?subject=Serial%3A%20" + serial + "&body=https%3A%2F%2Fqr.hussmann.com%2F%3FserialNumber%3D" + serial;
        }
        return "mailto:QRCodesupport@hussmann.com?subject=Model%3A%20" + model + "&body=https%3A%2F%2Fqr.hussmann.com%2F%3FModelNumber%3D" + model;
    }


    React.useEffect(() => {
        const getPartsUrl = async () => {
            try {
                let response = await fetch("PartsSearchUrl");
                if (!response.ok) {
                    throw "Unable to get url.";
                }
                let data = await response.json();
                setPartsUrl(data.url);
            }
            catch (exception) {
                alert(exception);
            }
        }
        getPartsUrl();
    }, []);

    return (
        <Card className={classes.root}>
            <div>
                <img
                    className={classes.image}
                    src={img || logo}
                    title={product}
                    onError={onError}
                />
            </div>
            <CardHeader
                title={product}
                subheader={model}
            />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">{productDescription}</Typography>
            </CardContent>
            <CardActions className={classes.cardAction}>
                <Button component="a" size="small" color="primary" href={getEmail()}>
                    Email Tech Support
                </Button>
                {serial &&
                    <Button component="a" size="small" color="primary" href={partsUrl + serial} target="_blank">
                        View Performance Parts
                    </Button>
                }
            </CardActions>
        </Card>
    );
}